import classNames from 'classnames';

import { Link, type GeneralLinkProps } from './link';

export const TextLink = ({ className, ...props }: GeneralLinkProps) => {
  return (
    <Link
      {...props}
      className={classNames(
        'underline text-[var(--mui-palette-text-primary)] hover:text-[var(--mui-palette-text-secondary)]',
        className
      )}
    >
      {props.children}
    </Link>
  );
};
